<template>
  <div class="p-5 border-t">
    <div class="flex items-center -mx-2px">
      <div class="flex items-center h-10 pl-3 pr-2 bg-white border">
        <input
          ref="SearchInput"
          v-model="search"
          v-focus
          class="SearchInputX2 w-full mr-2 text-gray-700 text-s leading-normal focus:outline-none focus:border-none"
          placeholder="Filter Landscape"
        />
        <lm-icon-button
          :icon="search === '' ? 'search' : 'close'"
          svg
          @click="search = ''"
        />
      </div>
      <lm-dropdown
        class="ml-auto"
        :items="orderOptions"
        icon="sort"
        :selected-item="selectedOrder"
        tooltip="Order by"
        @select="onSelectOrder"
      />
      <favorite-list
        class="ml-2"
        :selected="showOnlyFavorite"
        @change="onFavorite"
      />
    </div>
    <ul class="mt-5 space-y-4">
      <li
        v-for="landscape in landscapeList"
        :key="landscape._id"
        class="flex items-start"
      >
        <lm-icon-button
          class="mr-2"
          :icon="landscape.favorite ? 'star' : 'starBorder'"
          svg
          svg-size="18"
          :tooltip="
            (landscape.favorite ? 'Remove from' : 'Add to') + ' favorites'
          "
          @click="markAsfavorite(landscape)"
        />
        <div class="w-full">
          <span
            class="block w-56 mb-1 text-gray-700 text-s font-mono uppercase leading-tight cursor-pointer hover:text-highlight"
            :class="{'text-highlight': isSelected(landscape)}"
            @click="goToLandscape(landscape)"
          >
            {{ landscape.name }}
          </span>
          <span class="block text-xxs text-gray-300 capitalize font-mono">{{
            landscape.currentUser.role.toLocaleLowerCase()
          }}</span>
        </div>
        <lm-badge
          v-if="numMentions(landscape) > 0 && !landscape.premiumLocked"
          :num="numMentions(landscape)"
          :tooltip="badgeMsg(numMentions(landscape))"
          class="flex-shrink-0 cursor-default"
        />
        <lm-icon-button
          v-if="landscape.premiumLocked"
          icon="lock"
          class="text-gray-500"
          svg
          svg-size="18"
          tooltip="Landscape locked"
          disabled
        />
      </li>
    </ul>
    <p
      v-if="showOnlyFavorite && !favoriteLandscapes"
      class="my-4 text-center text-xs text-gray-500"
    >
      There is no favorite Landscapes.<br />
      <span
        class="text-highlight underline cursor-pointer"
        @click="onFavorite(false)"
        >Remove filter</span
      >
    </p>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {orderBy} from 'lodash'
import FavoriteList from '@/components/ui/icons/FavoriteList'
import LmBadge from '@/components/ui/LmBadge'
import LmDropdown from '@/components/ui/LmDropdown'
import LmIconButton from '@/components/ui/LmIconButton'
import {Modal, Order} from '@/lib/definitions'
import {orderOptions, getSorter} from '@/lib/sortOptions'
export default {
  name: 'LandscapesBlock',
  components: {LmBadge, LmIconButton, FavoriteList, LmDropdown},
  data() {
    return {
      search: '',
      showOnlyFavorite: false,
      orderOptions: orderOptions(
        [
          Order.NAME,
          Order.ROLE,
          Order.FAVORITE_LANDSCAPE,
          Order.JOINED_NEW,
          Order.JOINED_OLD
        ],
        'landscapes'
      ),
      selectedOrder: {}
    }
  },
  computed: {
    ...mapGetters(['landscapes', 'currentLandscape']),
    ...mapGetters({
      landscapesSortBy: 'preferences/landscapesSortBy',
      landscapesFilterFavorite: 'preferences/landscapesFilterFavorite'
    }),
    selectedLandscape() {
      if (this.currentLandscape) return this.currentLandscape.slug
      else return null
    },
    landscapeList() {
      const landscapeList = this.landscapes.filter(l => {
        const fav = this.showOnlyFavorite ? l.favorite : true
        const search =
          !this.search || l._name.includes(this.search.toLowerCase())
        return fav && search
      })
      const sorter = getSorter(this.selectedOrder.criteria)
      return orderBy(landscapeList, sorter.field, sorter.order)
    },
    favoriteLandscapes() {
      return this.landscapes.some(landscape => landscape.favorite)
    }
  },
  mounted() {
    this.showOnlyFavorite = this.landscapesFilterFavorite
    this.selectedOrder =
      this.orderOptions.find(o => o.criteria === this.landscapesSortBy) || {}
  },
  methods: {
    onFavorite(selected) {
      this.showOnlyFavorite = selected
      this.$store.dispatch('preferences/save', {
        landscapesFilterFavorite: selected
      })
    },
    onSelectOrder(item) {
      this.selectedOrder = item
      this.$store.dispatch('preferences/save', {
        landscapesSortBy: item.criteria
      })
    },
    numMentions(landscape) {
      return landscape.mentions || 0
    },
    badgeMsg(num) {
      return `${num} ${this.$options.filters.pluralizeWord(
        'notification',
        num
      )} pending`
    },
    isSelected(landscape) {
      return landscape.slug === this.selectedLandscape
    },
    markAsfavorite(landscape) {
      this.$store.dispatch('toggleFavorite', {
        landscapeSlug: landscape.slug,
        favorite: !landscape.favorite
      })
    },
    goToLandscape(landscape) {
      if (landscape.premiumLocked)
        this.$router.pushQuery({submodal: Modal.UPGRADE_PLAN})
      else {
        if (this.isSelected(landscape)) return
        this.$router.push({
          name: 'info',
          params: {landscapeSlug: landscape.slug}
        })
        this.$emit('toLandscape')
      }
    }
  }
}
</script>

<style>
.js-focus-visible .SearchInputX2.focus-visible {
  outline: none !important;
  border: none !important;
}
</style>
